export const brand = {
  name: 'etrainu',
  domain: 'assess.etrainu.com',
  showOrgSwitch: true
};
